export default {
  list: null
}
